import React, { useEffect, useState } from "react";
import {
  Container,
  Input,
  FormGroup,
  Label,
  Button,
  FormText,
  Row,
  Col,
} from "reactstrap";
import TableRoot from "./tables/TableRoot";
import AddMachine from "./AddMachine";
import UpdateViewMachine from "./UpdateViewMachine";
import Shimmer from "commonComponents/Shimmer";
import { useDispatch, useSelector } from "react-redux";
import { fetchMachineById, fetchMachineList } from "./redux/dispatcher";

// import { BULK_UPLOAD_SAMPLE_DATA } from 'utils/pdfList'
import useDebouncedEffect from "commonComponents/DeboucedEffect";
import BULK_UPLOAD_SAMPLE_DATA from "../../assets/docs/Sample_Machine_Data.xlsx";
import ButtonWithToopltip from "../../commonComponents/ButtonWithTooltip";
import QrCodeModal from "./qrCode/QRCodeModal";
import BulkUpload from "./bulkUpload/BulkUpload";

function Index({ }) {
  const dispatch = useDispatch();
  const machineList = useSelector((state) => state.machineListReducer) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [singleMachineData, setSingleMachineData] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    machineList?.data?.pagination?.currentPage || 1
  );
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [isShimmer] = useState(machineList.isLoading);
  const [isBulkUploadView, setIsBulkUploadView] = useState(false);
  const [totalPages, setTotalPages] = useState(
    machineList?.data?.pagination?.totalPages || 1
  );
  //Qr-Code generation new code
  const [isQrCodeGeneratorView, setQrCodeGeneratorView] = useState(false)

  useEffect(() => {
    setTotalPages(machineList?.data?.pagination?.totalPages || 1);
    setCurrentPage(machineList?.data?.pagination?.currentPage || 1);
  }, [machineList?.data?.pagination?.totalPages]);

  useEffect(() => {
    setCurrentPage(machineList?.data?.pagination?.currentPage || 1);
  }, [machineList?.data?.pagination?.currentPage]);

  useEffect(() => {
    dispatch(fetchMachineList({ searchQuery: "", currentPage, rowsPerPage }));
  }, [dispatch, currentPage]);

  useDebouncedEffect(
    () => {
      dispatch(fetchMachineList({ searchQuery, currentPage, rowsPerPage }));
    },
    [searchQuery, rowsPerPage],
    1000
  );

  useEffect(() => {
    if (machineList?.selectedMachine) {
      setSingleMachineData(machineList.selectedMachine[0]);
    }
  }, [machineList?.selectedMachine]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
  };

  const handleEdit = (id) => {
    dispatch(fetchMachineById(id, setIsUpdate));
  };

  const handleDelete = (id) => { };

  const handleView = (id) => {
    dispatch(fetchMachineById(id, setIsViewOnly));
  };
  const handleDownload = (e) => {
    e.preventDefault();
    const link = document.createElement("a");
    link.href = BULK_UPLOAD_SAMPLE_DATA;
    link.download = "SampleData.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleBulkUploadModel = (e) => {
    e.preventDefault();
    setIsBulkUploadView(true);
  };

  //new added
  const handleQrCodeGeneratorModal = (e) => {
    e.preventDefault();
    setQrCodeGeneratorView(true)
  }


  useEffect(() => {
    console.log(machineList); // Log machineList to debug its structure
  });

  const tableData = machineList?.data?.data || [];

  // const totalPages = 2;

  return (
    <>
      <div className="col-12 d-flex justify-content-end stickyFilter">
        <Container fluid>
          <Row className="mt-4 mb-3 d-flex justify-content-between align-items-center">
            {/* <Col
              xs={12}
              md={6}
              className="mb-3 d-flex justify-content-start justify-content-custom"
            > */}
            {/* <FormGroup className="mr-3">
                            <Button onClick={handleBulkUploadModel} color="primary">
                                Upload Machine List
                            </Button>
                        </FormGroup> */}

            {/* <div>
                <h4
                  style={{
                    color: "#135674",
                    cursor: "pointer",
                    fontSize: "1.1rem",
                    marginTop: "12px",
                    borderBottom: "2px solid #135674",
                    display: "inline-block", // This ensures the border only spans the text width
                  }}
                  onClick={handleBulkUploadModel}
                >
                  Upload Machine List
                </h4>
              </div>
              <div>
                <Button
                  onClick={handleDownload}
                  color="primary"
                  className="ml-4"
                >
                  <i className="fa-solid fa-cloud-arrow-down mr-1"></i> Download
                  Sample
                </Button> */}
            {/* <h4
                                style={{
                                    color: '#135674',
                                    cursor: 'pointer',
                                    marginTop: '8px',
                                    marginLeft: '40px',
                                    borderBottom: '2px solid #135674',
                                    display: 'inline-block' // This ensures the border only spans the text width
                                }}
                                onClick={handleDownload}
                            >
                                Download Sample Excel
                            </h4> */}
            {/* </div>
            </Col> 
           */}
            <Col className="d-flex justify-content-center mx-0 px-0">
              <FormGroup className="w-100 mb-0">
                <Label for="searchInput" hidden>
                  Search
                </Label>
                <Input
                  type="text"
                  id="searchInput"
                  value={searchQuery}
                  onChange={(e) => {
                    handleSearchChange(e);
                    setCurrentPage(1);
                  }}
                  style={{ width: "350px" }}
                  placeholder="Search by Machine Name or Company Name"
                />
              </FormGroup>
            </Col>
            <Col
              className="d-flex justify-content-end align-items-center mx-0 px-0"
              style={{ gap: "1rem" }}
            >
              <div>
                {isUpdate || isViewOnly ? (
                  <UpdateViewMachine
                    isViewOnly={isViewOnly}
                    setIsUpdate={setIsUpdate}
                    setIsViewOnly={setIsViewOnly}
                    data={singleMachineData}
                    searchQuery={searchQuery}
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                  />
                ) : (
                  <AddMachine />
                )}
              </div>
              <div>
                <ButtonWithToopltip
                  icon={"fa-file-import"}
                  onClickAction={handleBulkUploadModel}
                  tooltipLabel={"Import Machine List"}
                  targetId={"importMachineList"}
                />
              </div>
              {/* <div>
                <ButtonWithToopltip
                  icon={"fa-cloud-arrow-down"}
                  onClickAction={handleDownload}
                  tooltipLabel={"Download Sample"}
                  targetId={"downloadSample"}
                />
              </div> */}
              <div>
                <ButtonWithToopltip
                  icon={"fa-qrcode"}
                  onClickAction={handleQrCodeGeneratorModal}
                  tooltipLabel={"Generate Qr Code"}
                  targetId={"qrCodeGeneration"}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div>
        {isShimmer ? (
          <Shimmer />
        ) : (
          <TableRoot
            header={[
              "Sr. No.",
              "Machine Name",
              "Model",
              "Size",
              "Number",
              "Company",
              "Status",
              "Action",
            ]}
            tableData={tableData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        )}
      </div>
      {isBulkUploadView ? (
        <BulkUpload isBulkUploadView={isBulkUploadView} setIsBulkUploadView={setIsBulkUploadView} sampelDownLoader={handleDownload} />
      ) : (
        " "
      )}
      {isQrCodeGeneratorView ? (<QrCodeModal setQrCodeGeneratorView={setQrCodeGeneratorView} />) : ("")}
    </>
  );
}

export default Index;
